<template>
<div class="mainMenu">

    <img class="logo" src="@/assets/GodEnergi_logo.svg">
    <div>{{wdm.version }}<br>{{wdm.system }}</div>
    <div class="azureAuthentication"><azureAuthentication /></div>
</div>

</template>
  
<script>

import azureAuthentication from '@/components/azureAuthentication.vue'
/*
<nav>
    <router-link to="/">Hjem</router-link> |
    <router-link to="/about">Om</router-link>
</nav>
*/

export default {
  name: 'mainMenu',
  inject:[ 'wdm'],
  props: { },
  components: {azureAuthentication},
  data() { return {  version: '1.0.0'}},
  created() {   },

}

</script>

<style scoped>

.mainMenu {
    background-color: #81B532;
    width: 100%;
    height: 110px;
    color: white;
    margin: 0px;
}

.azureAuthentication {
    position: absolute;
    right: 10px;
    top: 10px;
    height: 90px;
    width: 100px;
    border:0px solid black;
}

nav {
  padding: 30px;
}

nav a {
  font-weight: bold;
  color: white;
}

nav a.router-link-exact-active {
  color: white;
}

nav a:hover {
    color: grey;
}
</style>